
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.37 2.167C4.698 1.247 4.32 0 3.324 0c-.996 0-1.374 1.246-1.048 2.167h2.096zM7.522 5.55a3.225 3.225 0 100 6.45 3.225 3.225 0 000-6.45zm.756 4.391c-.229-.01-.406-.213-.396-.454.01-.242.202-.43.43-.422.228.01.405.212.396.454-.01.242-.202.43-.43.422zm.644-1.448c-.214.055-.436-.09-.496-.326-.06-.234.066-.468.28-.523.215-.054.437.091.497.326.06.234-.066.469-.28.523zm.874 1.183c-.202 0-.365-.197-.365-.439s.163-.438.365-.438c.202 0 .366.196.366.438s-.164.439-.366.439z"}}),_c('path',{attrs:{"d":"M5.048 5.947A5.537 5.537 0 004.48 4.9c-.44-.65-.442-1.397-.334-1.972H2.5c.108.575.107 1.322-.334 1.972-.836 1.235-1.035 2.304-.849 4.205.154 1.582.694 2.7.694 2.7h2.624s.074-.153.175-.427a3.747 3.747 0 01.238-5.43z"}})])
          )
        }
      }
    